export class SavedTyresDetails{
    constructor(tyreTypeId, brand, type, description, ean, numberId) {
        this.tyreTypeId = tyreTypeId;
        this.brand = brand;
        this.type = type;
        this.description = description;
        this.ean = ean;
        this.numberId = numberId;
    }
}